export function getApiBase(): string {
  return window.location.hostname;
}
